/**
 * @fileoverview The `rel` a link carries (LIFE-SHORTLISTED-001 P9.1). Pure; consumed by
 * `<SmartLink>`.
 *
 * What KIND of destination an href is — `classifyHref` — is owned by `@puffin-core/block-schema`
 * (P5.1), so the judgement that stores a `url` field and the one that renders it are one function.
 *
 * @module @puffin-core/marketing-shell/links/linkRel
 */

/**
 * The `rel` a link carries. An external link never leaks the opener or the referrer; a sponsored
 * (affiliate / paid) destination says so (search engines require it); `nofollow` on request.
 *
 * @param {{external: boolean, sponsored?: boolean, nofollow?: boolean}} options
 * @returns {string|undefined}
 */
export function buildLinkRel({ external, sponsored = false, nofollow = false }) {
  const tokens = [
    ...(external ? ['noopener', 'noreferrer'] : []),
    ...(sponsored ? ['sponsored'] : []),
    ...(nofollow ? ['nofollow'] : []),
  ];
  return tokens.length > 0 ? tokens.join(' ') : undefined;
}
